<template>
  <v-row dense class="mx-0">
    <v-col cols="12" lg="7">
      <v-card elevation="0" rounded="lg" class="pa-2 pt-2 h-full">
        <h6 class="text-subtitle-1 font-weight-bold mb-0 px-2">Top Eventos</h6>
        <v-skeleton-loader v-if="loading" type="table" />
        <v-data-table
          v-else
          :headers="topEventsHeaders"
          :items="topEvents || []"
          dense
          hide-default-footer
          :items-per-page="10"
          no-data-text="Nenhum evento com faturamento no período"
        >
          <template v-slot:item.name="{ item }">
            <div class="d-flex align-center py-1">
              <div class="ml-n2">
                <v-img
                  :src="item.cover"
                  :aspect-ratio="16 / 9"
                  height="48"
                  :width="48 * (16 / 9)"
                  class="mr-2 rounded"
                />
              </div>
              <div>
                <div class="font-weight-medium">{{ item.name }}</div>
                <div class="text-caption text--secondary">
                  {{ item.organizationName }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item.ticketsSold="{ item }">
            {{ item.ticketsSold | number }}
          </template>
          <template v-slot:item.barRevenue="{ item }">
            {{ item.barRevenue | currency }}
          </template>
          <template v-slot:item.totalRevenue="{ item }">
            <span class="font-weight-bold">{{
              item.totalRevenue | currency
            }}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-col>

    <v-col cols="12" lg="5">
      <v-card elevation="0" rounded="lg" class="pa-2 pt-2 h-full">
        <h6 class="text-subtitle-1 font-weight-bold mb-0 px-2">
          Faturamento por Meio de Pagamento
        </h6>
        <v-skeleton-loader v-if="loading" type="table" />
        <v-data-table
          v-else
          :headers="paymentHeaders"
          :items="paymentRows"
          dense
          hide-default-footer
          :items-per-page="-1"
          no-data-text="Nenhum pagamento no período"
        >
          <template v-slot:item.ticketAmount="{ item }">
            {{ item.ticketAmount | currency }}
          </template>
          <template v-slot:item.barAmount="{ item }">
            {{ item.barAmount | currency }}
          </template>
          <template v-slot:item.totalAmount="{ item }">
            <span class="font-weight-bold">{{
              item.totalAmount | currency
            }}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashboardRankings",
  props: {
    topEvents: { type: Array, default: () => [] },
    revenueByMethod: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      topEventsHeaders: [
        { text: "Evento", value: "name", sortable: false },
        {
          text: "Ingressos",
          value: "ticketsSold",
          align: "end",
          sortable: false,
        },
        {
          text: "Fat. Bar",
          value: "barRevenue",
          align: "end",
          sortable: false,
        },
        {
          text: "Fat. Total",
          value: "totalRevenue",
          align: "end",
          sortable: false,
        },
      ],
      paymentHeaders: [
        { text: "Meio", value: "method", sortable: false },
        {
          text: "Ingresso",
          value: "ticketAmount",
          align: "end",
          sortable: false,
        },
        { text: "Bar", value: "barAmount", align: "end", sortable: false },
        { text: "Total", value: "totalAmount", align: "end", sortable: false },
      ],
    };
  },
  computed: {
    paymentRows() {
      const ticket = this.revenueByMethod?.ticket || [];
      const bar = this.revenueByMethod?.bar || [];
      const map = {};

      for (const row of ticket) {
        const key = row.paymentType || row.method;
        map[key] = {
          method: row.method,
          ticketAmount: row.amount || 0,
          barAmount: 0,
          totalAmount: row.amount || 0,
        };
      }

      for (const row of bar) {
        const key = row.paymentType || row.method;
        if (!map[key]) {
          map[key] = {
            method: row.method,
            ticketAmount: 0,
            barAmount: 0,
            totalAmount: 0,
          };
        }
        map[key].barAmount = row.amount || 0;
        map[key].totalAmount = map[key].ticketAmount + map[key].barAmount;
      }

      return Object.values(map).sort((a, b) => b.totalAmount - a.totalAmount);
    },
  },
};
</script>
